import { PageHeader } from "@/components/Bits";
import OutlookConnect from "@/components/OutlookConnect";

export default function Outlook() {
  return (
    <>
      <PageHeader eyebrow="Email connection" title="Outlook" />
      <OutlookConnect />
    </>
  );
}
